import React from "react";
import { NavLink } from "react-router-dom";
import logoInstitution from '../../assest/images/Header.png';
import ContactUs from "../../components/content/contact-us/ContactUs";
import InstitutionInformation from "../../components/content/institution-information/InstitutionInformation";
import './AboutInstitution.scss';

export default class AboutInstitutionRoute extends React.PureComponent<{ statusPage?: string | null }, { statusPage: number }> {

    constructor(props: any) {
        super(props);
        this.state = { statusPage: 1 };
    }

    componentDidMount() {
        if (this.props.statusPage !== null && this.props.statusPage !== undefined)
            this.setState({ statusPage: Number.parseInt(this.props.statusPage) });
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.statusPage !== this.props.statusPage && this.props.statusPage !== null && this.props.statusPage !== undefined)
            this.setState({ statusPage: Number.parseInt(this.props.statusPage) });
    }

    render(): React.ReactNode {
        let { statusPage } = this.state;
        let content;
        if (statusPage === 1) {
            content = (<>
                <InstitutionInformation/>
            </>)
        }
        if (statusPage === 2) {
            content = (<>             
                <ContactUs/>
            </>)
        }
        return (<>
            <div className="about-header">
                <img src={logoInstitution} alt="submit report icon" />
                <div className="close-icon">
                    <NavLink to={"/Dashboard"}> 
                        <span className="mdi mdi-close mdi-light"></span>
                    </NavLink>
                </div>
            </div>
            <div className="content-menu reward-route-area" style={{height:"91vh",top: "120px"}}>
                <div className="col-12">
                    <div className="tk-inline" style={{ marginBottom: "3px" }}>
                        <div className={"col-6 notspace header-title " + (statusPage === 1 ? "active" : "")} onClick={() => this.setState({ statusPage: 1 })}>
                            <label>درباره‌ی موسسه</label>
                        </div>
                        <div className={"col-6 notspace header-title " + (statusPage === 2 ? "active" : "")} onClick={() => this.setState({ statusPage: 2 })}>
                            <label>ارتباط با ما</label>
                        </div>
                    </div>
                </div >
                <div className="dropdown-list">
                    <div className="col-12 px-4">
                        <div className="tk-aling-right tk-padding-top col-12">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}